module.exports = __webpack_public_path__ + "static/media/Contents.8c685df6.svg";